(ns frontend.ui.component.lp-portal.donut-chart.view
  (:require
   [common.number-utils :as nu]
   [frontend.ui.component.chart.utils :as chart-utils]
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.style.theme.core :as theme]
   [frontend.utils :as fu]))

(defn ^{:jsdoc ["@nocollapse"]} pct-point-formatter
  []
  (this-as
   js-data-point
    (let [point (js->clj js-data-point
                         :keywordize-keys
                         true)]
      (str "<strong>"
           (or (:key point)
               (:x point))
           "</strong><br> "
           (util/->percent-1-decimal (/ (:percentage point) 100))))))

(defn ^{:jsdoc ["@nocollapse"]} legend-formatter
  []
  (this-as
   js-data-point
    (let [point (js->clj js-data-point
                         :keywordize-keys
                         true)
          color-index (fu/aget-in point ["colorIndex"])
          legend-name (fu/aget-in point ["name"])]
      (str "<strong "
           ;"style='color:" (:color data) ";'"
           ">"
           (nu/int->letters color-index)
           ") "
           "</strong> "
           legend-name))))

(defn donut-chart-config
  [data
   {:keys [data-label-formatter _legend-layout legend-align legend-vertical-align
           legend-formatter-fn editable? preserve-order?]}]
  (let [sorted-data (cond->> data
                      :always (remove (fn [[_k v]]
                                        (not (number? v))))
                      (and (not editable?) (not preserve-order?)) (sort-by second)
                      (and (not editable?) (not preserve-order?)) (reverse))
        data (concat (take 9 sorted-data)
                     (when (> (count sorted-data) 9)
                       [[(str "Other " (- (count sorted-data) 9))
                         (->> sorted-data
                              (drop 9)
                              (map second)
                              (apply +))]]))]
    {:chart       {:type :pie}
     :colors      (or (util/custom-colors)
                      (util/gradient-colors [:lp-report :chart :donut :gradient-start]
                                            [:lp-report :chart :donut :gradient-end]
                                            (count data)))
     :tooltip     {:outside         true
                   :useHtml         true
                   :backgroundColor (theme/color [:page-bg :bg])
                   :style           {:opacity         1
                                     :backgroundColor (theme/color [:page-bg :bg])}
                   :formatter       pct-point-formatter}
     :legend      {:align          (or legend-align :center)
                   :verticalAlign  (or legend-vertical-align :bottom)
                   :labelFormatter (or legend-formatter-fn legend-formatter)
                   ;:layout        (or legend-layout :vertical)
                   }
     :plotOptions {;; Make pie hollow (donut)
                   :pie {:innerSize    "60%"
                         :size         "70%"
                         :showInLegend true

                         :dataLabels   {:connectorShape "crookedLine"
                                        :textOverflow   "none"
                                        :useHTML        true
                                        :formatter
                                        (or data-label-formatter
                                            chart-utils/meur-label-formatter)}}}
     :series      [{:data data}]}))

(defn donut-chart-config-lifeline
  [data
   {:keys [data-label-formatter _legend-layout legend-align legend-vertical-align
           legend-formatter-fn editable?]}]
  (let [sorted-data (cond->> data
                      :always (remove (fn [[_k v]]
                                        (not (number? v))))
                      (not editable?) (sort-by second)
                      (not editable?) (reverse))
        data (concat (take 10 sorted-data)
                     (when (> (count sorted-data) 10)
                       [[(str "Other " (- (count sorted-data) 10))
                         (->> sorted-data
                              (drop 10)
                              (map second)
                              (apply +))]]))]
    {:chart       {:type :pie}
     :colors      (or (util/custom-colors)
                      (util/gradient-colors [:lp-report :chart :donut :gradient-start]
                                            [:lp-report :chart :donut :gradient-end]
                                            (count data)))
     :tooltip     {:outside         true
                   :useHtml         true
                   :backgroundColor (theme/color [:page-bg :bg])
                   :style           {:opacity         1
                                     :backgroundColor (theme/color [:page-bg :bg])}
                   :formatter       pct-point-formatter}
     :legend      {:align          (or legend-align :center)
                   :verticalAlign  (or legend-vertical-align :bottom)
                   :labelFormatter (or legend-formatter-fn legend-formatter)
                   :enabled false}
     :plotOptions {:pie {:innerSize    "40%"
                         :size         "60%"
                         :showInLegend true

                         :dataLabels   {:connectorShape "crookedLine"
                                        :textOverflow   "none"
                                        :useHTML        true
                                        :enabled true
                                        :distance 14
                                        :formatter
                                        (or data-label-formatter
                                            chart-utils/meur-label-formatter)}}}
     :series      [{:data data}]}))

#_(defn donut-chart
  [data]
  [chart (donut-chart-config data nil)])

#_(defn donut-chart-svg
  [data]
  (chart-svg "highcharts" (donut-chart-config data nil)))
